import { useEffect, useState } from "react";
import { UseFormReturn, useWatch } from "react-hook-form";
import { inputCss } from "./native.comp";
import CheckIcon from "../../icons/check.icon";
import XMarkIcon from "../../icons/xMark.icon";
import LoadingOvalIcon from "../../icons/loadingOval.icon";

export function ValueUpdateInput({
  methods,
  fieldName,
  placeholder,
  handleSubmit,
  currentValue,
  disabled,
}: {
  methods: UseFormReturn<any>;
  fieldName: string;
  placeholder?: string;
  handleSubmit: (price: number) => Promise<boolean>;
  currentValue: number;
  disabled?: boolean;
}) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [prevValue, setPrevValue] = useState(currentValue);
  const value = useWatch({ name: fieldName, control: methods.control });

  const onSubmit = async () => {
    setIsSubmitting(true);
    const res = await handleSubmit(value as number);
    if (res) setPrevValue(Number(value));
    setIsSubmitting(false);
  };

  const onCancel = () => {
    methods.setValue(fieldName, prevValue);
  };

  useEffect(() => {
    setPrevValue(currentValue);
  }, [currentValue]);

  const showIcons = !disabled && !isSubmitting && value !== undefined && Number(value) !== prevValue;

  return (
    <div className="relative inline-block">
      <input
        type="number"
        {...methods.register(fieldName, {
          required: "Invalid value",
          valueAsNumber: true,
        })}
        defaultValue={prevValue}
        disabled={disabled}
        className={`${inputCss} w-24 sm:w-32 ${showIcons ? "pr-12" : ""} ${disabled ? "opacity-50 cursor-not-allowed" : ""}`}
        placeholder={placeholder}
      />

      {showIcons && (
        <div className="absolute inset-y-0 right-2 flex items-center space-x-1">
          <button type="button" onClick={onSubmit} className="text-green-600 hover:text-green-800 ml-1">
            <CheckIcon className="w-4 h-4" />
          </button>
          <button type="button" onClick={onCancel} className="text-red-500 hover:text-red-700">
            <XMarkIcon className="w-4 h-4" />
          </button>
        </div>
      )}

      {isSubmitting && (
        <div className="absolute inset-y-0 right-2 flex items-center">
          <LoadingOvalIcon className="w-5 h-5" />
        </div>
      )}
    </div>
  );
}
